import Constant from '@/const';
import axios from 'axios';

const putStatusLaboratory = async payload => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/laboratory/status/${payload._id}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putStatusLaboratory;
